/**
 * @name Location
 * @function
 * @description 오시는길
 */

import { ImgText } from "../components/ImgText";
import { Map, MapMarker } from "react-kakao-maps-sdk";

export const Location = (): JSX.Element => {
  return (
    <div>
      <ImgText title="Location" text="캠핑장 찾아오시는 길" />
      <div className="flex flex-col justify-center items-center pb-6">
        <div className="p-3 pt-6 sm:p-12 ">
          <p className="text-2xl sm:text-3xl font-extrabold text-point text-center">
            위치안내
          </p>
          <div className="border-2 border-gray mt-6 relative flex flex-col sm:flex-row max-w-[20rem] sm:max-w-[48rem]  rounded-xl bg-white bg-clip-border text-gray-700 shadow-md">
            <div className="sm:ml-3 flex justify-center items-center relative m-0 overflow-hidden rounded-none bg-transparent bg-clip-border text-gray-700 shadow-none">
              <Map
                center={{ lat: 37.5421332, lng: 127.1681501 }}
                style={{
                  width: "20rem",
                  height: "20rem",
                  borderRadius: "30px",
                }}
              >
                <MapMarker
                  position={{ lat: 37.5421332, lng: 127.1681501 }}
                ></MapMarker>
              </Map>
            </div>
            <div className="p-6">
              <p className="mt-3 block font-sans leading-relaxed text-gray-700 antialiased">
                <ul>
                  <li className="text-lg sm:text-xl font-bold text-point">
                    주소
                  </li>
                  <li className="text-base sm:text-lg ">
                    경기도 하남시 초이로 99번길 49-32
                  </li>
                  <li className="text-base sm:text-lg ">
                    49-32, Choi-ro 99beon-gil, Hanam-si, Gyeonggi-do, Republic
                    of Korea
                  </li>
                  <br />
                  <li className="text-lg sm:text-xl font-bold text-point">
                    문의 전화
                  </li>
                  <li className="text-base sm:text-lg ">010-8480-7114</li>
                  <br />
                  <li className="text-base sm:text-lg ">
                    ※ 문의 시간 09:00 ~ 19:00
                  </li>
                  <li className="text-base sm:text-lg ">
                    ※ 점심 시간 12:00 ~ 13:00
                  </li>
                </ul>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
